import React from "react";
import { Tooltip } from "@mui/material";
import Icon from "./Icon";

interface CopyButtonProps {
  value: string;
}

const CopyToClipBoard: React.FC<CopyButtonProps> = ({ value }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
  };

  return (
    <Tooltip title={"Copy to clipboard"}>
      <div className="rounded-full hover:bg-gray-100 cursor-pointer transition-colors" onClick={handleClick}>
        <Icon icon="chain" />
      </div>
    </Tooltip>
  );
};

export default CopyToClipBoard;
